var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"progress-container"},[_c('b-progress',{staticClass:"progress-bar-custom",attrs:{"height":"5vh"}},_vm._l((_vm.steps),function(step){return _c('b-progress-bar',{key:step.name,class:'step '+(step.name==_vm.currentStep?'active':'inactive'),attrs:{"value":100/_vm.steps.length}},[_vm._v(" "+_vm._s(step.label)+" ")])}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }